const tokenStatus = {
  isValid: 0, // user has valid token
  isInvalid: 1, // token is expired and user will need to login again
  // token is expired but new token can be requested without prompting to re-login
  requiresNewToken: 2,
};

export default tokenStatus;
